<template>
  <div>
    <v-flex xs12>
      <div class="migalha">
        <ul class="list-inline" >
          <li v-if="$verificaPerfilCadastrador()">
            <a href="/">Cadastrador</a>
          </li>
          <li v-else-if="$verificaPerfilHabilitador()">
            <a href="/">Validador</a>
          </li>
           <li v-else>
            <a href="/">Fornecedor</a>
          </li>
          <li class="iconMigalha">
            <v-icon>chevron_right</v-icon>
            <v-icon>chevron_right</v-icon>
          </li>
          <li>
            <strong>{{this.label}}</strong>
          </li>
        </ul>
        <div class="bg-red barraTitulo"></div>
      </div>
    </v-flex>
  </div>
</template>
<script>
export default {
  name: "migalha",
  props: {//Propriedades que o objeto recebe como parametro
    label: String
  }
};
</script>